import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 10.8.",
  "description": "",
  "published": "2011-08-11T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-10-8/swizec/2124"],
  "categories": "Alain Prost, Ayrton Senna, Brazil, Formula One, Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Ayrton_Senna_Imola_1989_Cropped3.jpg",
        "alt": "Defending champion Ayrton Senna won a second c...",
        "title": "Defending champion Ayrton Senna won a second c..."
      }}></img></p>
    <p>{`Today I learned that the strangest thing can make your blog behave erratically, strange and crash whenever you apply even a hint of load to it. Apparently the reason my blog has been behaving so bad lately is the foursquare plugin used to show off my latest location in the footer. Seems like it kept wanting to talk with the foursquare API every time somebody reloaded the page. This tended to take a while and thus made the whole page slow ... then when enough people did this, usually as a result of being frontpages on HackerNews ...`}</p>
    <p>{`... well the obvious happened. A bunch of open connections to the database, everyone cheerfully waiting for the foursquare plugin, until the database told the blog to fuck off because you're only allowed about 200 connections by design to keep the server somewhat safe. And eventually I started running out of all sorts of resources assigned to me.`}</p>
    <p>{`The issue seems to be fixed now ... time to figure out how to get the 100 euro back from the host I wanted to move to out of pure frustration last night when my blog was down yet again.`}</p>
    <p>{`Another thing that I learned was that Senna was a fucking awesome driver. Just simply the coolest guy ever. Awesome as a driver `}<em parentName="p">{`and`}</em>{` awesome as a human. That's rare, a lot of people who are professionally awesome tend to suck horribly as people. If you haven't yet, you should totally see the `}<a parentName="p" {...{
        "href": "http://www.imdb.com/title/tt1424432/"
      }}>{`documentary about Senna`}</a>{` called ... Senna.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.avclub.com/articles/senna,60240/"
        }}>{`Film: Movie Review: Senna`}</a>{` (avclub.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.wired.com/geekdad/2011/08/senna/"
        }}>{`The Story of Senna, Formula 1's Humble Hero`}</a>{` (wired.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://yeeeeed.wordpress.com/2011/07/11/day-257-when-kate-watched-the-senna-film/"
        }}>{`Day 257 - When Kate watched the Senna film!`}</a>{` (yeeeeed.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jalopnik.com/5823354/ayrton-sennas-singular-relentless-magic"
        }}>{`Ayrton Senna's singular, relentless magic `}{`[`}{`Video`}{`]`}</a>{` (jalopnik.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=90edf8ca-6236-4d88-8e96-c12a0e40e38f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      